module.exports = __webpack_public_path__ + "static/media/Sidebar.310509c9.jpg";